import clsx from 'clsx';
import { useAppMode, type AppMode } from './appMode';

const MODES: { value: AppMode; label: string }[] = [
  { value: 'simple', label: 'פשוט' },
  { value: 'full', label: 'מלא' },
];

const NAME_SCRIPTS: { value: boolean; label: string }[] = [
  { value: false, label: 'עברית' },
  { value: true, label: 'عربي' },
];

function Segmented<T>({
  title,
  options,
  value,
  onChange,
}: {
  title: string;
  options: { value: T; label: string }[];
  value: T;
  onChange: (v: T) => void;
}) {
  return (
    <div className="px-3 pb-3">
      <p className="text-muted mb-1.5 text-xs font-bold">{title}</p>
      <div className="bg-surface-soft rounded-control flex gap-1 p-1" role="radiogroup">
        {options.map((o) => (
          <button
            key={o.label}
            role="radio"
            aria-checked={value === o.value}
            onClick={() => onChange(o.value)}
            className={clsx(
              'rounded-control min-h-[40px] flex-1 text-sm font-bold transition-[background-color,color,transform] active:scale-[0.97]',
              value === o.value ? 'bg-surface text-brand shadow-sm' : 'text-ink-2'
            )}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}

/** Drawer user-card settings: פשוט / מלא (unless admin-forced) and worker-name script. */
export function AppModeToggle() {
  const { mode, setMode, forced, arabicNames, setArabicNames } = useAppMode();
  return (
    <>
      {!forced && <Segmented title="מצב תצוגה" options={MODES} value={mode} onChange={setMode} />}
      <Segmented
        title="שמות עובדים"
        options={NAME_SCRIPTS}
        value={arabicNames}
        onChange={setArabicNames}
      />
    </>
  );
}
